module.exports = __webpack_public_path__ + "img/upload.d4674711.svg";